import { render } from "./NewsCard.vue?vue&type=template&id=6bb2657e&scoped=true&ts=true"
import script from "./NewsCard.vue?vue&type=script&lang=ts"
export * from "./NewsCard.vue?vue&type=script&lang=ts"

import "./NewsCard.vue?vue&type=style&index=0&id=6bb2657e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb2657e"]])

export default __exports__